<template>
  <v-container grid-list-xl>
    <h2 class="pl-4">
      <span>Articles</span>
      <span class="green--text">Portfolio</span>
    </h2>
    <h3 class="pl-4">
        More on my <b><a href="https://ledevoreve.wordpress.com/author/mathxxl/">WordPress</a></b> page.
    </h3>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="project.dialog"
        lazy
        max-width="1000"
        v-for="project in projects"
        :key="project.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="project.poster"
                :alt="project.title"
                aspect-ratio="1.7778"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="cardTitle">{{project.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="project.dialog">
          <v-card-title class="cardTitle">
            {{project.title}}
          </v-card-title>
          <v-card-text>
            <h3>Link</h3>
          </v-card-text>
          <v-card-text>
            <a :href="project.link">{{project.link}}</a>
          </v-card-text>
          <v-card-text>
            <h3>Description</h3>
          </v-card-text>
          <v-card-text>
            <p>{{project.description}}</p>
          </v-card-text>
          <v-card-text>
            <h3>Preview</h3>
          </v-card-text>
          <v-card-media>
            <v-img contain max-height="500px" :src="project.demo_image"></v-img>
          </v-card-media>
          <v-card-text>
            <h3 class="headline mb-0">
              <span>Tags</span>
              <span class="right" >Date de publication</span>
            </h3>
            <v-chip color="green" text-color="white">{{project.tech.tech1}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech2}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech3}}</v-chip>
            <v-chip color="green" text-color="white">{{project.tech.tech4}}</v-chip>
            <v-chip class="right" color="green" text-color="white">{{project.date}}</v-chip>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: 'Articles Portfolio',
    titleTemplate: "%s ← Eldin's Space",
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        name: 'description',
        content:
          'Mathieu Baesen Articles portefolio'
      },
      { charset: 'utf-8' },
      { property: 'og:title', content: "Eldin' Space" },
      { property: 'og:site_name', content: "Eldin' Space" },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://eldin.space' },
      {
        property: 'og:description',
        content:
          'Mathieu Baesen Articles portfolio'
      }
    ]
  },
  data () {
    return {
      dialog: false,
      projects: [
        {
          dialog: false,
          title: 'Fate/Grand Order : Avalon le Fae, le songe d’une nuit d’été',
          poster: 'https://ledevoreve.files.wordpress.com/2023/07/lb6_cg.webp?w=620',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2023/07/lb6_cg.webp?w=620',
          href: '',
          description: 'En complément de l’article sur les spin-off de Fate, je vous propose également un petit article sur Avalon le Fae, la 6e Lostbelt de Fate/Grand Order ! Vous y retrouverez une partie review, et une partie analyse, et dieu sait qu’il y a des choses à en dire.',
          link: 'https://ledevoreve.wordpress.com/2023/08/07/fate-grand-order-avalon-le-fae-le-songe-dune-nuit-dete/',
          date: '07/08/2023',
          tech: {
            tech1: 'Jeu Vidéo',
            tech2: 'Analyse',
            tech3: 'Fate/Grand Order',
            tech4: 'Avalon le Fay'
          }
        },
      {
          dialog: false,
          title: 'Honkai Impact 3rd : Kiana et Mei, apprendre à aimer l’autre pour s’aimer soi-même',
          poster: 'https://ledevoreve.files.wordpress.com/2023/09/ch32_kiana_mei_2.png?w=620',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2023/09/ch32_kiana_mei_2.png?w=620',
          href: '',
          description: 'L’histoire de la première partie de Honkai Impact 3rd vient de toucher à son terme, après 6 ans et 35 chapitres d’histoire et divers courts-métrages d’animation. Cette histoire, c’était avant tout celle de son trio d’héroïnes, Kiana, Mei et Bronya. A cette occasion j’avais envie aujourd’hui de revenir plus particulièrement sur l’évolution de Kiana et Mei au travers de leur relation, et quel est le message qu’on peut tirer de l’aboutissement de celle-ci.',
          link: 'https://ledevoreve.wordpress.com/2023/03/31/honkai-impact-3rd-kiana-et-mei-apprendre-a-aimer-lautre-pour-saimer-soi-meme/',
          date: '31/03/2023',
          tech: {
            tech1: 'Jeu Vidéo',
            tech2: 'Analyse',
            tech3: 'Honkai Impact 3rd',
            tech4: 'MiHoYo'
          }
        },
        {
          dialog: false,
          title: 'Comment définir le genre du Magical Girl ?',
          poster: 'https://ledevoreve.files.wordpress.com/2022/02/mahoutsukai-sally.jpg?w=1240',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2022/02/mahoutsukai-sally.jpg?w=1240',
          href: '',
          description: 'En début d’année 2021 a été diffusé l’animé Wonder Egg Priority, cette histoire de jeunes filles qui combattent dans un autre monde des monstres afin de faire revenir à la vie leurs amies s’étant suicidé. Au delà de ce que l’on peut penser de cet animé, une remarque que j’ai parfois pu lire m’a intrigué : WEP serait un animé de Magical Girl. Sur le coup, cela me semblait absurde, mais je me suis alors posé la question : qu’est-ce qui définit le Magical Girl au fait ? Je vous propose donc ici mon analyse de ce genre, afin de répondre à la question : Wonder Egg Priority est-il un animé de Magical Girl ?',
          link: 'https://ledevoreve.wordpress.com/2022/01/20/comment-definir-le-genre-du-magical-girl/',
          date: '20/01/2022',
          tech: {
            tech1: 'Animation Japonaise',
            tech2: 'Analyse',
            tech3: 'Magical Girl',
            tech4: 'Genre Cinématographique'
          }
        },
        {
          dialog: false,
          title: 'Saki : Un Festival de Kan',
          poster: 'https://ledevoreve.files.wordpress.com/2021/08/saki.webp?w=620&zoom=2',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2021/08/saki.webp?w=620&zoom=2',
          href: '',
          description: 'Voilà bientôt un an que j’ai pu découvrir le Mahjong japonais, un jeu auquel j’ai beaucoup accroché et auquel je continue de jouer régulièrement. Mais cette découverte s’est également accompagnée de celle d’un anime dédié à ce même jeu qui m’aura aidé à l’apprécier d’autant plus : Saki. Aujourd’hui je vous propose donc une petite review de l’intégralité de Saki en anime !',
          link: 'https://ledevoreve.wordpress.com/2021/08/20/saki-un-festival-de-kan/',
          date: '20/08/2021',
          tech: {
            tech1: 'Animation Japonaise',
            tech2: 'Mahjong',
            tech3: 'Review',
            tech4: 'Manga'
          }
        },
        {
          dialog: false,
          title: 'Une introduction à la musique classique au travers de l\'animation japonaise',
          poster: 'https://ledevoreve.files.wordpress.com/2021/01/euphonium.jpg?w=1240',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2021/01/euphonium.jpg?w=1240',
          href: '',
          description: 'Cela fait bientôt 2 ans que j’ai (re)découvert ce qu’on appelle communément la musique classique. Mais cela fait relativement peu de temps que je l’ai découverte dans l’animation japonaise, et pourtant il y a beaucoup de bonnes choses à en tirer ! Alors que vous n’y connaissiez rien dans ce domaine et que cela vous intéresse, ou que vous soyez déjà expérimenté mais cherchiez de nouvelles interprétations de vos pièces préférées, suivez-moi dans cette présentation de ce que peut être la musique classique, au travers d’interprétations diverses issues de l’animation japonaise.',
          link: 'https://ledevoreve.wordpress.com/2020/05/21/pourquoi-madoka-magica-a-t-il-marque-lanimation-japonaise/',
          date: '01/02/2021',
          tech: {
            tech1: 'Animation Japonaise',
            tech2: 'Musique',
            tech3: 'Article Primé',
            tech4: 'Compositeurs'
          }
        },
        {
          dialog: false,
          title: 'Otherside Picnic : La ballade pas du tout chill ou comment écrire une histoire angoissante',
          poster: 'https://ledevoreve.files.wordpress.com/2020/12/otherside-picnic.png',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2020/12/otherside-picnic.png',
          href: '',
          description: 'En avril dernier (oui ça paraît loin), l’éditeur J-Novel Club proposait quelques volumes de son catalogue numérique gratuitement à l’occasion des premiers confinements un peu partout dans le monde. Ce fut pour moi l’occasion de commencer une série qui me faisait de l’œil depuis une certaine interview, Otherside Picnic de Iori Miyazawa et illustrée par shirakaba.',
          link: 'https://ledevoreve.wordpress.com/2020/12/18/otherside-picnic-la-ballade-pas-chill-du-tout-ou-comment-ecrire-une-histoire-angoissante/',
          date: '18/12/2020',
          tech: {
            tech1: 'Light Novel',
            tech2: 'Yuri',
            tech3: 'Horreur',
            tech4: 'Analyse'
          }
        },
        {
          dialog: false,
          title: 'Pourquoi Madoka Magica est un animé marquant ?',
          poster: 'https://ledevoreve.files.wordpress.com/2020/05/madoka-magica-1.jpg',
          demo: false,
          demo_image: 'https://ledevoreve.files.wordpress.com/2020/05/madoka-magica-1.jpg',
          href: '',
          description: 'Diffusé il y a presque 10 ans maintenant, Puella Magi Madoka Magica jouit encore aujourd’hui d’une grande popularité et d’une excellente réputation. Considéré comme une révolution du genre Magical Girl par certains, cette histoire bien plus sombre qu’on ne pourrait le croire au premier abord a tellement marqué son public que n’importe quel anime reprenant une formule similaire est considéré comme l’un de ses successeurs. Toutefois d’autres voix s’élèvent pour affirmer que Madoka n’a rien inventé, et que sa formule n’est pas du tout révolutionnaire. C’est dans cette perspective que je me suis demandé : dans quelle mesure Madoka Magica a-t-il eu une influence sur l’animation ?',
          link: 'https://ledevoreve.wordpress.com/2020/05/21/pourquoi-madoka-magica-a-t-il-marque-lanimation-japonaise/',
          date: '21/05/2020',
          tech: {
            tech1: 'Animation Japonaise',
            tech2: 'Analyse',
            tech3: 'Magical Girl',
            tech4: 'Premier Article'
          }
        }
      ]
    }
  }
}
</script>

<style  scoped>
.cardTitle{
  text-align: center;
  color: green ;
  font-size: x-large;
  justify-content: center;
}
.vid{
  text-align: center;
}
</style>
